import { AxiosResponse } from 'axios';
import api from './api';

export default {
  animalByUid(uid: string): Promise<AxiosResponse> {
    return api.get(`/rgas/animal-by-uid/${uid}`);
  },
};
